import React from "react";

import Exception from "../Exception";

import List from "./List";
import Root from "./Root";

const basePath = "/category";
const resourceRoute = [
  {
    menu: "Working Category",
    icon: "apartment",
    path: basePath,
    component: Root,
    routes: [
      {
        path: `${basePath}`,
        exact: true,
        component: List,
      },
      {
        component: () => <Exception code="404" />,
      },
    ],
  },
];

export default resourceRoute;
